module.exports = __webpack_public_path__ + "media/containers/common/Images/icHospital-22cd264ecfc67c0954d6c2e0bc14c416.png";